<template>
    <div class="bg_white" >
      <van-nav-bar
      title="互动问答"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      >
      <template #right>
          <van-icon name="wap-home-o" size="20"/>
      </template>
      </van-nav-bar>

      <div>
        <van-cell  :label="detail.descp">
          <van-tag type="success" v-if="detail.status==1">已回复</van-tag>
          <van-tag type="primary" v-if="detail.status==0">待回复</van-tag>
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <span class="custom-title">{{ detail.contents }}</span>
          </template>
        </van-cell>

        <van-cell icon="comment-circle-o" v-for="item in replys" :key="item.id">
          <span>{{ item.descp }}</span>
        </van-cell>
      </div>
    </div>
</template>

<script>
import { getAskDetail } from '../../api/custom';
export default {
  data() {
    return {
        param:{
          id:""
        },
        detail:{

        },
        replys:[]
    }

   },
   created(){
    this.param.id = this.common.getQueryString("id")
    this.getDetail();
   },
   methods: {
   getDetail(){
      getAskDetail(this.param.id).then(res=>{
        this.detail=res.data.ask
        this.replys=res.data.replys
      })
   },
    onClickLeft() {
    this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },
    
  }

};
</script>

<style lang="less">
.header {
  
  border-bottom: 1px solid #ccc;
  text-align: center;
  width: 100%;
  height: 300px;
  line-height: 450px;
}
.loginbox{
  box-sizing: border-box;
  padding:15px;
  text-align: center;
  
  
}
.header image {
  width: 200px;
  height: 200px;
}

.content {
   margin-left: 20px;
   margin-top: 20px;
  // margin-bottom: 90px;
  font-size: 14px;
  text-align: left;
}
.mt20{
  margin-top: 40px;
}
.content text {
  display: block;
  color: #9d9d9d;
  margin-top: 40px;
}

.bottom {
  border-radius: 80px;
  margin: 70px 50px;
  font-size: 35px;
}

</style>

